import { render, staticRenderFns } from "./announcements-table-actions.vue?vue&type=template&id=72067c7d"
import script from "./announcements-table-actions.vue?vue&type=script&lang=js"
export * from "./announcements-table-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports